<template>
  <div class="robot-detail">
<!--    <div class="img">-->
<!--      <img :src="detail.img"  alt="">-->
<!--    </div>-->
    <div class="content">
<!--      <div class="robot-h1">{{detail.title}}</div>-->
      <div class="robot-desc" id="desc"><!--{{detail.desc}}--></div>
<!--      <div class="robot-h1">产品优势</div>-->
<!--      <div class="robot-goodness">-->
<!--        <div v-for="(item, index) in detail.goodness" :key='"g_"+index'>{{item}}</div>-->
<!--      </div>-->
      <div class="data-source">*数据来源于博智林机器人实验室</div>
      <button class="robot-btn" @click="isShow = true">业务洽谈</button>
    </div>
    <Qrcode v-model="isShow"></Qrcode>
  </div>
</template>
<script>
import Qrcode from "@/components/Qrcode.vue";
// import { cardData } from "./robot";
export default {
  name: 'robot-detail',
  components: {
    Qrcode
  },
  data(){
    return {
      isShow: false,
        detail: {},
    }
  },
  created () {
    this.initData();

  },
  methods:{
      async initData(){
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          const { id } = this.$route.query;
          console.log("contentId",id);


          let contents = await this.$getContents(this.$channels.robotList);
          let list =[];
         await contents.filter(item => item.id == id).forEach(
              item => {
                  list.push({
                      id: item.id,
                      avatar: process.env.VUE_APP_BASE_API+item.imageUrl,
                      img: process.env.VUE_APP_BASE_API+item.imageUrl,
                      title: item.title,
                      subtitle: item.subTitle,
                      desc: item.body.replaceAll("src=\"/","src=\""+process.env.VUE_APP_BASE_API+"/"),
                      goodness:item.summary.split("\n")
                  })
              }
          );

          //console.log("list",list)
          this.detail = list[0];


          let insertDiv = document.getElementById("desc");

          insertDiv.innerHTML = this.detail.desc;


          let maxWidth =await insertDiv.clientWidth;
          console.log("maxWidth",maxWidth);
          if (insertDiv.getElementsByTagName("video").length > 0) {

              await Array.from(insertDiv.getElementsByTagName("video")).forEach(item => {


                  let videoWidth = item.clientWidth;
                  console.log("videoWidth",videoWidth);
                  if (videoWidth>maxWidth){
                      item.style.width = maxWidth+"px";
                  }

              });
          }
          if (insertDiv.getElementsByTagName("img").length > 0) {

              await Array.from(insertDiv.getElementsByTagName("img")).forEach(item => {



                  let img = new Image();
                  img.src = item.src;
                  img.onerror = ()=>{ console.log("img.onerror",item.src)};
                  img.onload = () =>{
                      console.log("img.onload",item.src);
                      let ratio;  // 缩放比例
                      let width = item.naturalWidth;
                      let height = item.naturalHeight;

                      console.log("width",width);
                      console.log("height",height);

                      // 检查图片是否超宽
                      // if (width > maxWidth) {
                      //计算缩放比例
                      ratio = maxWidth / width;
                      height = height * ratio;    // 计算等比例缩放后的高度
                      item.style.width = maxWidth+"px";
                      item.style.height  = height+"px";
                      // }
                      console.log("item.style.width",item.style.width);
                      console.log(" item.style.height", item.style.height);
                  };

                  item.style.marginLeft = "0px";
                  item.style.marginRight = "0px";

              });
          }
          console.log("robot detail",this.detail)
      },

  }
}
</script>
<style lang="less" scoped>
.robot-detail{
  .img{
    img{
      width: 750px;
      height: 637px;
    }
  }
  .content{
    padding: 100px 48px 132px; 
  }
  .robot-h1{
    font-size: 48px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #333333;
  }
  .robot-desc{
    margin: 32px 0 64px;
    font-size: 28px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #666666;
    line-height: 56px;
  }
  .robot-goodness {
    margin: 32px 0 64px;
    font-size: 28px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #666666;
    line-height: 56px;
  }
  .data-source{
    font-size: 28px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #999999;
    margin-bottom: 100px;
  }
  .robot-btn{
    width: 654px;
    height: 80px;
    color: #ffffff;
    background: #d8609e;
    border: none;
  }
}
</style>